module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<div>\n  <app-d3graph></app-d3graph>\n  <app-map>\n    <!--  <agm-marker [latitude]=\"lat\" [longitude]=\"lng\"></agm-marker> -->\n  </app-map>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/visulisation/visulisation.component.html
// module id = ../../../../../src/app/visulisation/visulisation.component.html
// module chunks = main